import { computed } from 'vue';
import { useAccount } from 'dashboard/composables/useAccount';
import { usePolicy } from 'dashboard/composables/usePolicy';

// Acesso às CHAMADAS por provedor — SEPARADOS. Cada um exige:
//   • o módulo da empresa (`wavoip` / `astracall`) habilitado (Super Admin), E
//   • poder receber — admin/agente padrão sempre podem; funções personalizadas
//     só com a permissão específica.
// Espelha o padrão `moduleAllowed` do Sidebar (feature_modules + checkPermissions).
export function useWhatsappCallAccess() {
  const { currentAccount } = useAccount();
  const { checkPermissions } = usePolicy();

  const moduleOn = key => currentAccount.value?.feature_modules?.[key] !== false;

  const canReceiveWavoipCalls = computed(
    () =>
      moduleOn('wavoip') &&
      checkPermissions(['administrator', 'agent', 'wavoip_calls_receive'])
  );

  const canReceiveAstracallCalls = computed(
    () =>
      moduleOn('astracall') &&
      checkPermissions(['administrator', 'agent', 'astracall_calls_receive'])
  );

  return { canReceiveWavoipCalls, canReceiveAstracallCalls };
}
